const DISPLAY_CLASS = 'show-hidden-details'

class AvatarListController extends Controller {
  toggleRecipientDetails(event) {
    event.currentTarget.classList.toggle(DISPLAY_CLASS)
  }
}

export default AvatarListController



// WEBPACK FOOTER //
// ./app/components/people/assets/javascript/avatar-list-controller.js